export default "__VITE_PUBLIC_ASSET__8193d77f__"